"use strict";
/**
 * @module Client.Services
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Notification of unsubscription,
 */
exports.notifyUnsubscriptionService = {
    /**
     * Handle an inbound request.
     *
     * @param internal      the internal session instance
     * @param notification  the inbound notification
     * @param callback      the service reference callback
     */
    onRequest: function (internal, notification, callback) {
        callback.respond();
        internal.getRouting().unsubscribe(notification.id, notification.reason);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/client/services/notify-unsubscription-service.js
// module id = 1126
// module chunks = 1